import { Button } from '@/components/ui/button';
import { LoaderCircleIcon, Save } from 'lucide-react';

interface SaveButtonProps {
  isDirty: boolean;
  isUpdating: boolean;
  isInitialSetup?: boolean;
}

export function SaveButton({ isDirty, isUpdating, isInitialSetup }: SaveButtonProps) {
  return (
    <Button
      type="submit"
      className="w-fit min-w-[100px] flex"
      disabled={(!isDirty && !isInitialSetup) || isUpdating}
    >
      {isUpdating ? (
        <>
          <LoaderCircleIcon className="h-4 w-4 animate-spin mr-2" /> Saving
        </>
      ) : (
        <>
          <Save className="h-4 w-4 mr-2" />
          {isInitialSetup ? 'Save Changes' : 'Save'}
        </>
      )}
    </Button>
  );
}
